import { Platform } from 'react-native';

class SoundService {
  playSound(type: 'correct' | 'incorrect') {
    if (Platform.OS === 'web') {
      console.log(`Playing ${type} sound`);
      // For web, we could use the Web Audio API here
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      oscillator.connect(audioContext.destination);
      oscillator.frequency.setValueAtTime(type === 'correct' ? 800 : 400, audioContext.currentTime);
      oscillator.start();
      oscillator.stop(audioContext.currentTime + 0.2);
    } else {
      // For mobile, we'll just log for now
      console.log(`Playing ${type} sound on mobile`);
    }
  }
}

export const soundService = new SoundService(); 